export default __webpack_public_path__ + "static/media/Banese.cd0015d9.svg";